/* eslint-disable react/jsx-props-no-spreading */
import React, { SelectHTMLAttributes, useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import { Container, Error } from './styles';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
}

const Select: React.FC<SelectProps> = ({ name, children, ...rest }) => {
  const selectRef = useRef(null);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container isError={!!error}>
      <select defaultValue={defaultValue} ref={selectRef} {...rest}>
        {children}
      </select>
      <Error className="invalid-feedback">{error}</Error>
    </Container>
  );
};

export default Select;
